module.exports = __webpack_public_path__ + "static/img/select-img3.2363cc6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images1/select-img3.png
// module id = uOgv
// module chunks = 1